/**
 * Add To Cart
 */
app.cart = (function() {

    'use strict';

    var products = [],
    lastItemIndex = -1,
    singleCartTimeout, multipleCartTimeout = null,
    total = 0,
    redirectWindow = null,
    redirectEnabled = false,
    cartMode = 'shopping',
    defaultSubscriptionType = 'MONTHS',
    defaultSubscriptionInterval = 1,
    isEnrollment = false,

    self = {
        init: function(p, enrollment) {
            products = p;

            // unified shopping (not currently used)
            if (enrollment === true) {
                isEnrollment = true;
            }

            app.skava.applyDiscount();

            if (window.location.hash.indexOf('#checkout') > -1) {
                cartMode = 'checkout';
                $('#page').addClass('checkout');
                $('#page #pws').html('');
                app.main.toggleNavigation();

            } else if (window.location.hash === '#cart') {
                cartMode = 'cart-review';
                $('#page').addClass('cart-review');
                $('#page #pws').html('');

            } else {
                cartMode = 'shopping';
                $('#page').removeClass('checkout');
                $('#page').removeClass('cart-review');
            }

            // load template
            Handlebars.registerPartial('enrollment-product-list', $('#template-partial-enrollment-product-list').html());
            Handlebars.registerPartial('enrollment-totals', $('#template-partial-enrollment-totals').html());
            app.main.getTemplate('page-cart', {}, true, self.render);
        },

        openRedirectWindow: function() {
            var html = app.main.getSettings().rebrand_enabled ? 'redirect2.html' : 'redirect.html';
            redirectWindow = window.open(html, '_blank');
            window.addEventListener('message', self.messageHandler, false);
        },

        messageHandler: function(e) {
            if (e.data == 'redirect-ready') {
                e.source.postMessage(app.main.lang('redirect_message'));
            }

            window.removeEventListener('message', self.messageHandler);
        },

        getCheckoutFormPageData: function() {
            var pageData = {};
            pageData.countries = app.skava.getFieldCountries();
            pageData.states = app.skava.getFieldStates();
            pageData.profile = app.main.getProfile();
            pageData.products = self.getCartItems();
            pageData.gifts = app.skava.getCartGifts();
            pageData.grandTotal = total;
            return pageData;
        },

        render: function() {
            var pageData;

            var finishPageSetUp = function () {
                // external templates loaded into #template, can now be accessed normally
                if (cartMode === 'cart-review') {
                    pageData = self.getCheckoutFormPageData();

                    $('#page').append(app.main.getTemplate('page-cart-review', pageData));
                    app.skava.renderCartReview('#cart-review-container', pageData);

                } else if (cartMode === 'checkout') {
                    pageData = self.getCheckoutFormPageData();

                    for (var i = 0; i < pageData.products.length; i++) {
                        if (pageData.products[i].isSubscription) {
                            pageData.hasSubscriptionProducts = true;
                            break;
                        }
                    }

                    $('#page').append(app.main.getTemplate('page-checkout', pageData));
                    app.skava.renderForm('#checkout-container', pageData);
                }

                $('#page').append(app.main.getTemplate('view-cart', {}));
                app.page.initHelpTips();

                $('.cart-link').click(function(e) {
                    e.preventDefault();

                    app.main.track('Product', 'ga-checkout');

                    // make link relative
                    var href = $(this).attr('href').replace(/^(?:\/\/|[^\/]+)*\//, '/');

                    // don't replace culture for Enroll to Buy links
                    if ($(e.target).hasClass('learn-more') ) {
                        // replace culture in link with filtered culture
                        // to cover DE, AT, SE cases

                        var filteredCulture = app.main.getCurrentCulture({ filter: true });
                        filteredCulture = filteredCulture.split('-')[0] + '_' + filteredCulture.split('-')[1].toUpperCase();

                        var updatedLink = '/' + filteredCulture + '/' + href.split('/').slice(2).join('/');

                        href = updatedLink;
                    }

                    if (redirectEnabled) {
                        self.openRedirectWindow();
                    }

                    self.getResponse({
                            url: servicesURL[mode] +'xsrf-token',
                            method: 'POST'

                        }, function(response, xhr) {
                            self.getCartRedirect(app.cookie.get('XSRF-TOKEN'), href);

                        }, function(e) {
                            // error
                            app.message.error('Error getting xsrf token');
                            app.main.track('Redirect Error', 'xsrf call failed', app.main.getProfile().member_id);
                            console.log(e);
                        }, 'text');
                });

                $('.cart-icon').off().click(function() {
                    if ($(window).width() <= 1024) {
                        if ($('#view-cart-multiple').hasClass('is-active')) {
                            self.hideMultipleItemCart(false);

                        } else {
                            self.displayMultipleItemCart(false);
                        }
                    }
                });

                // display multiple item cart
                // when icon is clicked
                $('.cart-icon').on('click', function() {
                    app.main.track('Product', 'ga-cart-displayed');
                    if ($(window).width() >= 1024) {
                        self.displayMultipleItemCart(true);

                    } else {
                        self.hideMultipleItemCart(true);
                    }
                });

                $('.view-cart').off().click(function() {
                    if (app.main.getSettings().skavaEnabled && self.getCartItems()) {
                        window.location.hash = '#cart';

                    } else {
                        if (!$('#view-cart-multiple').hasClass('is-active')) {
                            var desktop = ($(window).width() >= 1024);
                            self.displayMultipleItemCart(desktop);
                        }
                    }
                });

                // add to cart button click event
                $('.cart-add').off().click(function(e) {
                    e.preventDefault()
                    try {
                        var isSubscription = false;
                        if (app.main.getSettings().skavaEnabled) {
                            var productId = $(e.target).attr('data-product_id');
                            // todo: one-time-order no longer exists?
                            var oneTimeOrder = $('#' + productId + '-one-time-order')[0].checked;
                            if (oneTimeOrder) {
                                isSubscription = false;
                            } else {
                                isSubscription = true;
                            }
                        }

                        var itemId = $(e.target).data('item_id'),
                            quantity = parseInt($(e.target).siblings('.select').find('input.field-quantity').val(), 10),
                            data = {
                                itemId: itemId,
                                quantity: quantity ? quantity : 1,
                                isSubscription: isSubscription
                            };

                        console.log('adding to cart', data);

                        self.addToCart(data, function () {
                            // button success state
                            if (!$(e.target).hasClass('cart-success')) {
                                $(e.target).html('<i></i>'+ app.main.lang('added_to_cart_cta')).addClass('cart-success');
                            }

                            self.displaySingleItemCart();

                            if (app.main.getSettings().unified_shopping_enabled) {
                                // show special pv ticker
                                app.enroll.calcPV(self.getCartItems());
                            }
                        });
                    }

                    catch(err) {
                        app.main.track('Product', 'ga-add-to-cart-error');
                    }
                });

                self.updateBadge();
                self.setCartTotal();

                if (app.main.getSettings().unified_shopping_enabled) {
                    // show special pv ticker
                    app.enroll.calcPV(self.getCartItems());
                }

                // make buttons active
                $('.cart-disabled').removeClass('cart-disabled');
                $('.cart-hidden').removeClass('cart-hidden');

                // show cart item options for first varient items (since it's what's shown by default in pick-list)
                $('pws-item:first-child').addClass('active');
                app.page.hideLoader();
            };

            if (app.main.getSettings().skavaEnabled) {

                app.page.showLoader();

                var errorHandler = function(err) {
                    console.log('unhandled error', err);
                    // app.message.error('Could not load cart');
                    app.page.hideLoader();
                    finishPageSetUp();
                    // testing: if error was because of an invalid cart, clear it
                    // app.skava.sendRequest({
                    //     url: '/cart/',
                    //     method: 'DELETE'
                    // },
                    // function(res) {
                    //     console.log('delete cart success');
                    // },
                    // function(err) {
                    //     console.log('delete cart failed. status '+ err.status);
                    // });
                };

                // Handle regular cart
                var currentMode = app.skava.getShoppingMode(app.skava.CART_SHOPPING_MODE);
                if (currentMode !== app.skava.CART_SHOPPING_MODE) {
                    // Avoid regular cart sync if this is a BWM checkout
                    finishPageSetUp();
                } else {
                    self.syncRegularCart(self.getCartItems(), function() {
                        finishPageSetUp();
                    }, errorHandler);
                }

            } else {
                finishPageSetUp();
            }
        },

        clear: function() {
            localStorage.setItem('myyl-cart', null);
            self.updateBadge();
        },

        hasItems: function() {
            var items = self.getCartItems();
            if (items == null || items.length == 0) {
                $('.view-cart').hide();
                return false;
            }

            $('.view-cart').show();
            return true;
        },

        hideIfVisible: function() {
            if ($('#view-cart-single').hasClass('is-active')) {
                self.hideSingleItemCart();
            }

            if ($('#view-cart-multiple').hasClass('is-active')) {
                self.hideMultipleItemCart();
            }
        },

        getCartItems: function() {
            var localCart = JSON.parse(localStorage.getItem('myyl-cart')) || [];
            app.skava.applyDiscount();

            // merge product promo with local cart data
            localCart.forEach(function(item) {
                var product = app.cart.findProductByID(item.item_id, 'item_id');

                if (product) {
                    if (product.promo) {
                        item.promo = product.promo;
                    }
                }
            });

            return localCart;
        },

        setCartItems: function(items, cb) {
            if (app.main.getSettings().skavaEnabled) {
                app.page.showLoader();

                self.syncRegularCart(items, function(result) {
                    // clear promo info before saving locally
                    items.forEach(function(item) {
                        if (item.promo) {
                            // console.log(item.name +' promo cleared in localStorage');
                            delete item.promo;
                        }
                    });

                    localStorage.setItem('myyl-cart', JSON.stringify(items));
                    self.setCartTotal(result.grandTotal);
                    self.updateBadge();
                    app.page.hideLoader();

                    if (self.hasItems()) {
                        $('.view-buttons').show();

                    } else {
                        $('.view-buttons').hide();
                    }

                    if (cb) {
                        cb();
                    }
                },

                function(err) {
                    var response = '',
                        errorMsg = 'Could not add item to cart';
                    
                    try {
                        response = JSON.parse(err.responseText);

                        // console.log(response);
                        // todo: handle this - {code: 'EOCA0000013', message: 'Out of stock', timeStamp: 1649363309395}

                        if (response.message) {
                            errorMsg += ': '+ response.message;
                        }

                        if (response.errorMessage) {
                            errorMsg += ': '+ response.errorMessage;
                        }

                        if (cb) {
                            cb();
                        }

                    } catch(error) {
                        // do nothing
                    }

                    // app.message.error(errorMsg);
                    app.page.hideLoader();
                });

            } else {
                localStorage.setItem('myyl-cart', JSON.stringify(items));
                self.setCartTotal();
                self.updateBadge();

                if (cb) {
                    cb();
                }
            }
        },

        displaySingleItemCart: function() {
            var cartItems = self.getCartItems();

            if (self.hasItems() == false) {
                self.hideSingleItemCart(true);
                return;
            }

            clearTimeout(singleCartTimeout);

            if ($('#view-cart-multiple').hasClass('is-active')) {
                self.hideMultipleItemCart(false);
            }

            if ($('#view-cart-single').hasClass('is-active')) {
                $('#view-cart-single').fadeOut(200);
            }

            self.hideLocationChooser();

            var product = cartItems[lastItemIndex];

            setTimeout(function() {
                $('#cart-bg').addClass('is-active');
                $('#view-cart-single').html(app.main.getTemplate('view-cart-single', {
                    product: product,
                    total_price: self.getCartTotal()
                }));

                if ($(window).width() >= 1024) {
                    $('#view-cart-single').fadeIn(200);
                    $('#view-cart-single').promise().done(function() {
                        $('#view-cart-single').addClass('is-active');
                    });

                } else {
                    $('#view-cart-single').show().addClass('is-active');
                }

                self.setupClickEvents();

                // keep cart open if mouse enters cart area
                $('#view-cart-single').mouseenter(function() {
                    clearTimeout(singleCartTimeout);
                });

                // hide cart if user's mouse leaves cart area
                $('#view-cart-single').mouseleave(function() {
                    setTimeout(function() {
                        self.hideSingleItemCart(true);
                    }, 2000);
                });

                $('#select-list').on('mouseover', function() {
                    clearTimeout(singleCartTimeout);
                });

                self.hideSingleItemCart(true);
            }, 200);
        },

        displayMultipleItemCart: function() {
            var cartItems = self.getCartItems(),
                moreItems = cartItems.length > 3 ? true : false,
                cartProducts = [],
                cartMonthly = [];

            if (self.hasItems() == false) {
                return;
            }

            // split cart items into one-time order or subscription
            cartItems.forEach(function(item) {
                if (item.isSubscription) {
                    cartMonthly.push(item);

                } else {
                    cartProducts.push(item);
                }
            });

            clearTimeout(multipleCartTimeout);

            // hide single item cart
            // if visible
            if ($('#view-cart-single').hasClass('is-active')) {
                self.hideSingleItemCart(false);
            }

            self.hideLocationChooser();

            $('.cart-icon').off('mouseenter');
            $('#view-cart-multiple').html(app.main.getTemplate('view-cart-multiple', {
                products: cartProducts,
                subscriptions: cartMonthly,
                total_products: self.getCartTotalProducts(),
                total_price: self.getCartTotal()
            }));

            $('#cart-bg').addClass('is-active');
            $('#view-cart-multiple').addClass('is-active');

            $('#page').off().on('click', function(e) {
                // ignore clicks
                // on select list,
                // view cart button,
                // and add to cart buttons
                if ($(e.target).parent()[0].id == 'select-list' ||
                    $(e.target).hasClass('view-cart') ||
                    $(e.target).parent().hasClass('view-cart') ||
                    $(e.target).parent().parent()[0].id == 'select-list' ||
                    $(e.target).hasClass('cart-add') ) {
                    return;
                }

                self.hideMultipleItemCart(true);
                $('#page').off('click');
            });

            $('#view-cart-multiple').off().on('click', function(e) {
                e.stopPropagation();
            });

            $('.close, .continue').off().click(function() {
                var desktop = ($(window).width() >= 1024);

                self.hideMultipleItemCart(desktop);
            });

            self.setupClickEvents();
        },

        hideLocationChooser: function() {
            if ($('#location-chooser').hasClass('is-active')) {
                app.location.toggle();
            }
        },

        setupClickEvents: function() {
            // set up checkout click
            // quantity selector
            // and remove link events

            $('.cart .checkout').off().on('click', function() {
                // moved to a function to enable unified shopping checkout
                self.checkOut();
            });

            $('.cart-selected').off().on('click', function() {
                var cartPos = $('.cart.is-active').position();
                var pos = $(this).position(),
                $parent = $(this).parent(),
                $select = $('#select-list');

                if ($parent.hasClass('is-active')) {
                    self.closeSelect();

                } else {
                    self.closeSelect();
                    $parent.addClass('is-active');
                    $(window).on('resize', self.closeSelect);

                    var cssPos = {
                        top: Math.round(pos.top) + 39,
                        left: Math.round(pos.left)
                    };

                    if (cartPos) {
                        cssPos.left = Math.round(cartPos.left + pos.left) + 1;
                    }

                    $select.addClass('fixed');
                    $select.css(cssPos).show();

                    $('li:not(.other)', $select).off().on('click', function() {
                        self.setQty($parent, $(this).text(), function () {
                            self.closeSelect();
                            self.refreshCart();
                        });
                    });
                }

                $('li.other input', $select)
                    .off().on('keyup blur', function(e) {
                        var num = $(this).val().replace(/\D/g, '');
                        $(this).val(num);

                        switch (e.keyCode) {
                            // enter/return
                            case 13:
                                self.setQty($parent, num, function () {
                                    self.closeSelect();
                                    self.refreshCart();
                                });
                            break;
                            // esc
                            case 27:
                                self.closeSelect();
                            break;
                        }
                    })
                    .on('focus', function() {
                       // disable the document mousedown handler so the blur event will take precedence
                       $('body,.carousel').off('mousedown touchstart');
                    })
                    .on('blur', function() {
                        if ($(this).val()) {
                            self.setQty($parent, $(this).val(), function () {
                                self.closeSelect();
                                self.refreshCart();
                            });
                        }
                    });

                // close the select drop-down when anything else is clicked
                $('body,.carousel').off().on('mousedown touchstart', function(e) {
                    // ignore on the select-list element or quantity field inside it (other)
                    if (e.target.parentElement.id != 'select-list' && e.target.parentElement.className != 'other') {
                        self.closeSelect();
                        $('body,.carousel').off('mousedown touchstart');
                    }
                });
            });

            // remove link click events
            $('.cart-remove-link').off().click(function(e) {
                var partNumber = $(this).data('part-number'),
                    itemId = $(this).data('item-id'),
                    isSubscription = $(this).data('is-subscription'),
                    cartItems = self.getCartItems(),
                    single = $('#view-cart-single').hasClass('is-active'),
                    otherItems = $.grep(cartItems, function (item, i) {
                        if (app.main.getSettings().skavaEnabled) {
                            return item.item_id != itemId || item.isSubscription != isSubscription;

                        } else {
                            return item.item_id != itemId;
                        }
                    });

                app.main.track('Product', 'ga-remove-from-cart', partNumber);
                self.setCartItems(otherItems, function () {
                    self.updateBadge();

                    if (app.main.getSettings().unified_shopping_enabled) {
                        app.enroll.calcPV(self.getCartItems());
                    }

                    // remove cart-success class
                    $('[data-item_id="' + itemId + '"]').removeClass('cart-success');

                    // console.log('cartItems.length', cartItems.length);
                    if (cartItems.length == 1) {
                        // last product removed, delete skava cart also
                        app.skava.deleteCart(function() {
                            //
                        });
                    }

                    if (otherItems.length == 0) {
                        if (single) {
                            self.hideSingleItemCart(false);

                        } else {
                            self.hideMultipleItemCart(false);
                        }

                        return;
                    }

                    if (single) {
                        self.hideSingleItemCart(false);

                    } else {
                        if (cartMode === 'cart-review') {
                            app.skava.renderCartReview('#cart-review-container', self.getCheckoutFormPageData());
                        }
                        self.displayMultipleItemCart(false);
                    }
                });
            });

            $('#link-loyalty').off().on('click', function(e) {
                e.preventDefault();
                var domain = 'www';

                if (['local', 'dev'].includes(mode)) {
                    domain = 'clone';
                }

                window.open('https://'+ domain +'.youngliving.com/us/en/myaccount/subscriptions', '_blank');
            });

            // disable quantity dropdown if open on scroll
            $('.cart-items').off('scroll').on('scroll', function() {
                console.log('scroll');
                if ($('#select-list').hasClass('fixed')) {
                    self.closeSelect();
                }
            });
        },

        refreshCart: function() {
            if ($('#view-cart-single').hasClass('is-active')) {
                self.refreshSingleItemCart();

            } else {
                self.refreshMultipleItemCart();
                $('.close, .continue').off().click(function() {
                    var desktop = ($(window).width() >= 1024);
                    self.hideMultipleItemCart(desktop);
                });
            }

            if (cartMode === 'cart-review') {
                app.skava.renderCartReview('#cart-review-container', self.getCheckoutFormPageData());
            }

            self.setupClickEvents();
        },

        refreshSingleItemCart: function() {
            var cartItems = self.getCartItems(),
                product = cartItems[lastItemIndex];

            $('#view-cart-single').html(app.main.getTemplate('view-cart-single', { product: product, total_price: self.getCartTotal() }));
        },

        refreshMultipleItemCart: function() {
            var moreItems = false,
                cartItems = self.getCartItems();

            if (self.hasItems() == false) {
                return;
            }

            if (cartItems.length > 3) {
                moreItems = true;
                cartItems = cartItems.slice(0, 3);
            }

            $('#view-cart-multiple').html(app.main.getTemplate('view-cart-multiple', {
                products: cartItems,
                total_price: self.getCartTotal(),
                total_products: self.getCartTotalProducts(),
                more_items: moreItems
            }));
        },

        hideSingleItemCart: function(slow) {
            var delay = slow? 3000: 0;
            $('#cart-bg').removeClass('is-active');

            singleCartTimeout = setTimeout(function() {
                if ($(window).width() >= 1024) {
                    $('#view-cart-single').fadeOut(200);
                    $('#view-cart-single').promise().done(function() {
                        $('#view-cart-single').hide().removeClass('is-active');
                        $('#view-cart-single').off('mouseenter');
                        $('#view-cart-single').off('mouseleave');
                        $('#view-cart-single .checkout').off('click');
                        $('#view-cart-single .cart-selected').off('click');
                        $('#view-cart-single').html('');
                        $('#select-list').off('mouseenter');
                    });

                } else {
                    $('#view-cart-single').hide().removeClass('is-active');
                    $('#view-cart-single').off('mouseenter');
                    $('#view-cart-single').off('mouseleave');
                    $('#view-cart-single .checkout').off('click');
                    $('#view-cart-single .cart-selected').off('click');
                    $('#view-cart-single').html('');

                    $('#select-list').off('mouseenter');
                }
            }, delay);

            if (cartMode === 'cart-review') {
                app.skava.renderCartReview('#cart-review-container', self.getCheckoutFormPageData());
            }
        },

        hideMultipleItemCart: function() {
            // var delay = slow? 300: 0;
            $('#cart-bg').removeClass('is-active');

            // multipleCartTimeout = setTimeout(function() {
                // if (slow) {
                    // $('#view-cart-multiple').fadeOut(200);
                    $('#view-cart-single').promise().done(function() {
                        $('#view-cart-multiple').removeClass('is-active');
                    });

                // } else {
                //     $('#view-cart-multiple').hide();
                // }

                // $('#view-cart-multiple').promise().done(function() {
                    $('#view-cart-multiple').removeClass('is-active');
                    // $('#view-cart-multiple .checkout').off('click');
                    // $('#view-cart-multiple .cart-selected').off('click');
                    // $('#view-cart-multiple').html('');

                    $('#page').off('click');
                    // $('.cart .close').off('click');
                    $('.cart-icon').on('click', function() {
                         // if ($(window).width() >= 1024) {
                            self.displayMultipleItemCart();

                         // } else {
                         //    self.hideMultipleItemCart(true);
                         // }
                    });
                // });
            // }, delay);

            if (cartMode === 'cart-review') {
                app.skava.renderCartReview('#cart-review-container', self.getCheckoutFormPageData());
            }
        },

        hideAllItemCart: function() {
            self.hideSingleItemCart(false);
            self.hideMultipleItemCart(false);
        },

        /**
         * Search for a product with given ID and return it
         */
        getProductByID: function(id) {
            if (typeof id == 'object') {
                id = id.product_id;
            }

            return defiant.json.search(products, '//*[item_id="'+ id +'"]')[0];
        },

        /**
         * Search for a product with given ID and return it
         */
        findProductByID: function(id, type) {
            if (!type) {
                type = 'product_id';
            }

            if (typeof id == 'object') {
                id = id.product_id;
            }

            // item_id may contain _1 at end
            if (typeof id == 'string') {
                var pieces = id.split('_');
                if (pieces.length) {
                    id = pieces[0];
                }
            }

            if (products.src && products.src.length) {
                // add starter kits
                for (var i=0; i<products.src.length; i++) {
                    if (products.src[i][type] == id) {
                        return products.src[i];
                    }
                }
            }
            return false;
        },

        getCartTotalProducts: function() {
            var cartItems = self.getCartItems();
            var totalProducts = 0;

            cartItems.forEach(function(item) {
                if (item.quantity) {
                    totalProducts += parseInt(item.quantity, 10);

                } else {
                    totalProducts++;
                }
            });

            return totalProducts;
        },

        getCartTotal: function() {
            return total;
        },

        setCartTotal: function(skavaGrandTotal) {
            total = 0;
            var cartItems = self.getCartItems();
            if (self.hasItems() == false) {
                return;
            }

            for (var i = 0; i < cartItems.length; i++) {
                var itemId = cartItems[i].item_id;
                // button success state
                if (!$('[data-item_id="' + itemId + '"]').hasClass('cart-success')) {
                    $('[data-item_id="' + itemId + '"]').html('<i></i>'+ app.main.lang('added_to_cart_cta')).addClass('cart-success');
                }

                if (app.main.getSettings().skavaEnabled) {
                    total += cartItems[i].price * cartItems[i].quantity;

                } else {
                    total += cartItems[i].retail_price_with_tax * cartItems[i].quantity;
                }
            }

            // Override with skava grand total
            if (app.main.getSettings().skavaEnabled) {
                if (app.skava.getCartData() && app.skava.getCartData().value) {
                    try {
                        total = app.skava.getGrandTotal() * 100;

                    } catch (err) {
                        // do nothing
                    }

                } else {
                    // todo: this probably isn't needed
                    if (skavaGrandTotal) {
                        total = skavaGrandTotal;
                    }
                }
            }

            // also update in-page est. total
            if (app.main.getSettings().unified_shopping_enabled) {
                $('.price.grand-total').text(app.global.currency(self.getCartTotal()));
            }
        },

        addToCart: function(viewmodel, cb) {
            var cartItems = self.getCartItems(),
                product = null;

            if (cartItems) {
                product = $.grep(cartItems, function (item, i) {
                    if (item.item_id == viewmodel.itemId) {
                        lastItemIndex = i;
                    }

                    return item.item_id == viewmodel.itemId && item.isSubscription === viewmodel.isSubscription;
                })[0];

            } else {
                cartItems = [];
            }

            // update

            if (product != null) {
                product.quantity += viewmodel.quantity;

                if (app.main.getSettings().skavaEnabled) {
                    product.isSubscription = viewmodel.isSubscription;
                }

            } else {
                // add
                product = self.getProductByID(viewmodel.itemId);
                product.quantity = viewmodel.quantity;

                if (app.main.getSettings().skavaEnabled) {
                    product.isSubscription = viewmodel.isSubscription;

                    if (!product.subscriptionInterval) {
                        product.subscriptionInterval = defaultSubscriptionInterval;
                    }
                }

                cartItems.push(product);
                lastItemIndex = cartItems.length-1;
            }

            // console.log('items in cart', self.getCartItems().length);

            if (app.main.getSettings().skavaEnabled && self.getCartItems().length == 0) {
                // this is the first item added in regular cart, clear an existing skava cart
                // as it could potentially have previously added bundle items
                app.skava.deleteCart(function() {
                    self.setCartItems(cartItems, cb);
                });

            } else {
                self.setCartItems(cartItems, cb);
            }
        },

        updateCart: function(viewmodel, cb) {
            var cartItems = self.getCartItems(),
                product = null;

            product = $.grep(cartItems, function (item, i) {
                if (item.item_id == viewmodel.itemId) {
                    lastItemIndex = i;
                }
                if (app.main.getSettings().skavaEnabled) {
                    return item.item_id == viewmodel.itemId && item.isSubscription == viewmodel.isSubscription;
                } else {
                    return item.item_id == viewmodel.itemId;
                }
            })[0];

            product.quantity = viewmodel.quantity;
            self.setCartItems(cartItems, cb);
        },

        updateBadge: function() {
            var cartItems = self.getCartItems(),
                numberOfItems = self.getCartTotalProducts();

            $('.notification-qty.notification-qty').html(numberOfItems);
            $('span.notification-qty').html(' (' + numberOfItems + ')');
        },

        /**
         * Close and disable and product quantity select lists
         */
        closeSelect: function() {
            $(window).off('resize', self.closeSelect);
            $('#select-list').removeClass('fixed');
            $('.select').removeClass('is-active');
            $('#select-list li').off('click');
            $('#select-list .other input').val('').off('keyup blur');
            $('#select-list').hide();
        },

         /**
         * Sets the quantity value based on selection or 'other' field entry
         */
        setQty: function($parent, num, cb) {
            num = parseInt(num, 10);

            if (num < 1 || isNaN(num)) {
                return;
            }

            var partnumber = $parent.data('part-number');
            var isSubscription = $parent.data('is-subscription');

            app.main.track('Product', 'ga-change-quantity', partnumber + '|' + num);

            $('.cart-selected', $parent).text(num);
            $('.field-quantity', $parent).val(num);

            self.updateCart({
                itemId: $parent.data('item-id'),
                quantity: num,
                isSubscription: isSubscription
            }, cb);
        },

        /**
         * Checkout button clicked
         */
        checkOut: function() {
            app.page.showLoader();
            app.main.track('Product', 'ga-checkout');
            if (redirectEnabled) {
                self.openRedirectWindow();
            }

            self.getResponse({
                url: servicesURL[mode] +'xsrf-token',
                method: 'POST'

                }, function(response, xhr) {
                    self.getCartRedirect(app.cookie.get('XSRF-TOKEN'), null);

                }, function(e) {
                    // error
                    app.message.error('Error getting xsrf token');
                    app.main.track('Redirect Error', 'xsrf call failed', app.main.getProfile().member_id);
                    console.log(e);
                },
            'text');
        },

        /**
         * Send X-XSRF-TOKEN and enrollment package data to back end to get cart redirect URL, then redirect to the URL
         */
        getCartRedirect: function(token, redirectURL) {
            if (app.main.getSettings().skavaEnabled) {
                window.location.hash = 'cart';
                return;
            }

            var data,
                header = {
                    name: 'X-XSRF-TOKEN',
                    value: token
                },
                items = self.getCartItems();

            if (redirectURL === null) {
                data = {
                    enroller_id: app.main.getProfile().member_id,
                    sponsor_id: app.main.getProfile().member_id,
                    country: app.location.getCurrentLocation(),
                    culture: app.main.getCurrentCulture({ filter: true }),
                    item_ids: [],
                    site_path: app.main.getProfile().site_path || app.main.getProfile().username
                };

            } else {
                data = {
                    enroller_id: app.main.getProfile().member_id,
                    sponsor_id: app.main.getProfile().member_id,
                    country: app.location.getCurrentLocation(),
                    culture: app.main.getCurrentCulture({ filter: true }),
                    item_ids: [],
                    site_path: app.main.getProfile().site_path || app.main.getProfile().username,
                    redirect_url: redirectURL
                };
            }

            if (items != null && items.length > 0) {
                for (var i = 0; i < items.length; i ++) {
                    for (var j = 0; j < items[i].quantity; j++) {
                        data.item_ids.push(items[i].item_id);
                    }
                }
            }

            if (!token) {
                app.message.alert({
                    type: 'error',
                    id: 'error-xsrf',
                    message: 'Missing XSRF token'
                });

                app.main.track('Redirect Error', 'missing xsrf token', app.main.getProfile().member_id);
                app.page.hideLoader();
                return;
            }

            self.getResponse({
                url: servicesURL[mode] + 'checkout',
                method: 'POST',
                data: data

            }, function(response, xhr) {

                try {
                    console.log('Cart redirect: ', response.checkout_uri);
                    if (app.main.getSettings().queueit_enabled) {
                        // redirect to yl redirect page
                        var page = ylURL[mode] +'myyl/?redirect=';
                        window.location.replace(page + encodeURIComponent(response.checkout_uri));

                    } else {
                        // redirect to checkout url
                        if (redirectEnabled) {
                            redirectWindow.location.assign(response.checkout_uri);
                            app.main.track('Redirect Success', 'redirectWindow.location', app.main.getProfile().member_id);

                        } else {
                            window.location.assign(response.checkout_uri);
                            app.main.track('Redirect Success', 'window.location', app.main.getProfile().member_id);
                        }
                    }

                } catch(e) {
                    app.message.error('Cart redirect failed.');
                    app.main.track('Redirect Error', 'window.location failed', app.main.getProfile().member_id);
                }

            }, function(jqXHR) {
                // error
                app.message.error('Error getting cart redirect.');
                app.main.track('Redirect Error', 'checkout call failed', app.main.getProfile().member_id);
            }, 'json', header);
        },

        /**
         * Connect to the services api and return the response
         */
        getResponse: function(obj, callback, errorcallback, dataType, header) {
            $.ajax({
                url: obj.url,
                method: obj.method,
                contentType: 'application/json; charset=utf-8',
                cache: false,
                dataType: dataType ? dataType : 'json',
                data: JSON.stringify(obj.data),
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                beforeSend: function(xhr) {
                    if (header) {
                        xhr.setRequestHeader(header.name, header.value);
                    }
                },
                success: function(response, status, xhr) {
                    if (typeof callback == 'function') callback(response, xhr);
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    if (typeof errorcallback == 'function') errorcallback(jqXHR);
                }
            });
        },

        syncRegularCart: function (localCartItems, cb, errorCb) {
            if (!localCartItems) localCartItems = [];
            
            if (localCartItems.length < 1) {
                cb([]);
                return;
            }

            // console.log('syncRegularCart', localCartItems);

            var currentMode = app.skava.getShoppingMode(app.skava.CART_SHOPPING_MODE);
            if (currentMode !== app.skava.CART_SHOPPING_MODE) {
                console.log('------------------------- REDIRECT syncRegularCart ----------------------');
                window.location.href = '#';
                window.location.reload();
                return;
            }

            var sync = function (skavaCartItems) {
                var cartChangesMade;

                var productsInCart = {
                    products: {}
                };

                var itemsToDelete = [];

                // loop through skava cart and make sure to toggle on items locally or delete to match
                for (var i = 0; i < skavaCartItems.length; i++) {
                    var sku = skavaCartItems[i].skus[0];
                    var isGift = skavaCartItems[i].isGift;
                    var productId = parseInt(sku.productId);
                    // var cartProduct = self.findProductByID(productId, 'product_id');
                    var cartProduct = self.findProductByID(sku.skuId, 'item_id');
                    var matchFound = false;
                    var category = 'products';

                    if (cartProduct) {
                        var itemId = cartProduct.item_id;
                        var isSubscription = skavaCartItems[i].isSubscription;

                        // var isSubscription = skavaCartItems[i].subscription;
                        // if (!isSubscription) {
                        //     isSubscription = false;

                        // } else {
                        //     isSubscription = true;
                        // }

                        var isSubscriptionIdSuffix = isSubscription ? '-subscription' : '';

                        if (!isGift) {
                            productsInCart[category][itemId + isSubscriptionIdSuffix] = skavaCartItems[i];

                        } else {
                            // ignoring gift
                        }

                        for (var x = 0; x < localCartItems.length; x++) {
                            if (localCartItems[x].item_id === itemId && localCartItems[x].isSubscription == isSubscription) {
                                matchFound = true;
                                break;

                            } else if (cartProduct.variants) {
                                for (var z = 0; z < cartProduct.variants.length; z++) {
                                    if (cartProduct.variants[z].item_id === itemId && localCartItems[x].isSubscription == isSubscription) {
                                        matchFound = true;
                                        break;
                                    }
                                }

                            } else {
                                // no match found
                            }
                        }
                    }

                    // item is not added, so remove it from the cart
                    if (!matchFound) {

                        if (isGift) {
                            // not deleting gift

                        } else {
                            console.log('going to delete', productId);
                            // todo: reason to add more than just itemId?
                            itemsToDelete.push({
                                productId: productId,
                                itemId: skavaCartItems[i].itemId,
                                category: category
                            });
                        }
                    }
                }

                var addItems = function (finishCb) {
                    // loop through local items and add to cart if missing in skava
                    var productsToAdd = [];

                    for (var i = 0; i < localCartItems.length; i++) {
                        var itemId = localCartItems[i].item_id;
                        var productId = localCartItems[i].product_id;
                        var quantity = localCartItems[i].quantity;
                        var isSubscription = localCartItems[i].isSubscription;

                        if (!isSubscription) isSubscription = false;

                        var isSubscriptionIdSuffix = isSubscription ? '-subscription' : '';
                        var subscriptionInterval = localCartItems[i].subscriptionInterval;
                        // var product = self.findProductByID(productId, 'product_id');
                        var product = self.findProductByID(itemId, 'item_id');
                        var productAlreadyInCart = false;

                        if (product) {
                            if (productsInCart.products[product.item_id + isSubscriptionIdSuffix]) {
                                productAlreadyInCart = true;
                                // console.log('in cart product', product.item_id);

                            // } else if (product.variants) {
                            //     for (var z = 0; z < product.variants.length; z++) {
                            //         if (productsInCart.products[product.variants[z].item_id + isSubscriptionIdSuffix]) {
                            //             productAlreadyInCart = true;
                            //             console.log('in cart variant', product.variants[z].item_id);
                            //             break;
                            //         }
                            //     }
                            }
                        }

                        // console.log(productAlreadyInCart, product);

                        if (!productAlreadyInCart && product) {
                            var addProduct = {
                                quantity: quantity,
                                skus: [
                                    {
                                        skuId: product.sku_id,
                                        productId: product.product_id.toString(),
                                        type: 'DEFAULT'
                                    }
                                ],
                                properties: {},
                                isSubscription: isSubscription
                            };

                            if (isSubscription) {
                                addProduct.subscription = {
                                    frequencyPeriod: subscriptionInterval,
                                    frequencyType: defaultSubscriptionType
                                };
                            }

                            productsToAdd.push(addProduct);
                        }
                    }

                    if (productsToAdd.length === 0) {
                        return finishCb();

                    } else {
                        console.log('adding to cart: ', productsToAdd);
                        cartChangesMade = true;
                        app.skava.sendRequest({
                            url: '/cart/',
                            method: 'POST',
                            data: JSON.stringify(productsToAdd)
                        }, finishCb, errorCb);
                    }
                };

                var deleteItems = function (finishCb) {
                    if (itemsToDelete.length === 0) {
                        return finishCb();
                    }

                    cartChangesMade = true;
                    var numProcessed = 0;
                    var numFailed = 0;
                    var errors = {};

                    for (var x = 0; x < itemsToDelete.length; x++) {
                        // todo: why isn't there an itemId (undefined) in some cases?
                        if (!itemsToDelete[x].itemId) {
                            // skip...
                            continue;
                        }

                        app.skava.sendRequest({
                            url: '/cart/' + itemsToDelete[x].itemId + '/',
                            method: 'DELETE'
                            }, function () {
                                numProcessed++;
                                if (numProcessed === itemsToDelete.length) {
                                    if (numFailed === 0) {
                                        return finishCb();
                                    } else {
                                        errorCb(errors.err1, errors.err2, errors.err3);
                                    }
                                }
                            }, function(err1, err2, err3) {
                                numFailed++;
                                numProcessed++;
                                if (numProcessed === itemsToDelete.length) {
                                    console.log('Failed to delete '+ numFailed +' items');
                                    errorCb(err1, err2, err3);
                                } else {
                                    errors.err1 = err1;
                                    errors.err2 = err2;
                                    errors.err3 = err3;
                                }
                        });
                    }
                };

                var updateItems = function(finishCb) {
                    // loop through local items and update skava cart items if needed
                    var productsToUpdate = [];

                    for (var i = 0; i < localCartItems.length; i++) {
                        var itemId = localCartItems[i].item_id;
                        var product = self.findProductByID(itemId, 'item_id');
                        var cartItemSubscriptionInterval = localCartItems[i].subscriptionInterval;
                        var cartItemIsSubscription = localCartItems[i].isSubscription;
                        if (!cartItemIsSubscription) cartItemIsSubscription = false;
                        var isSubscriptionIdSuffix = cartItemIsSubscription ? '-subscription' : '';
                        var cartItemQuantity = localCartItems[i].quantity;
                        var quantityMatches = true;
                        var itemToUpdate = null;
                        var skavaItemSubscriptionInterval = null;
                        var skavaItemIsSubscription;
                        var skavaItemQuantity;
                        var freqType;

                        if (productsInCart.products[product.item_id + isSubscriptionIdSuffix]) {
                            skavaItemIsSubscription = productsInCart.products[product.item_id + isSubscriptionIdSuffix].subscription;

                            if (skavaItemIsSubscription) {
                                freqType = productsInCart.products[product.item_id + isSubscriptionIdSuffix].subscription.frequencyType;
                                skavaItemSubscriptionInterval = defaultSubscriptionInterval;
                                skavaItemIsSubscription = true;

                            } else {
                                skavaItemIsSubscription = false;
                            }

                            skavaItemQuantity = productsInCart.products[product.item_id + isSubscriptionIdSuffix].quantity;

                            // If there's either a quantity or subscription interval change and both items are the same order type (isSubscription)
                            if (skavaItemQuantity !== cartItemQuantity /* && skavaItemIsSubscription === cartItemIsSubscription */) {
                                itemToUpdate = productsInCart.products[product.item_id + isSubscriptionIdSuffix].itemId;
                                quantityMatches = false;

                            } else if (skavaItemSubscriptionInterval !== cartItemSubscriptionInterval && skavaItemIsSubscription === cartItemIsSubscription && cartItemIsSubscription) {
                                itemToUpdate = productsInCart.products[product.item_id + isSubscriptionIdSuffix].itemId;
                                quantityMatches = false;
                            }

                        } else if (product.variants) {
                            for (var z = 0; z < product.variants.length; z++) {
                                if (productsInCart.products[product.variants[z].item_id + isSubscriptionIdSuffix]) {
                                    skavaItemSubscriptionInterval = null;
                                    skavaItemIsSubscription = productsInCart.products[product.variants[z].item_id + isSubscriptionIdSuffix].subscription;

                                    if (skavaItemIsSubscription) {
                                        freqType = productsInCart.products[product.variants[z].item_id + isSubscriptionIdSuffix].subscription.frequencyType;
                                        skavaItemSubscriptionInterval = defaultSubscriptionInterval;
                                        skavaItemIsSubscription = true;

                                    } else {
                                        skavaItemIsSubscription = false;
                                    }

                                    skavaItemQuantity = productsInCart.products[product.variants[z].item_id + isSubscriptionIdSuffix].quantity;

                                    // If there's either a quantity or subscription interval change and both items are the same order type (isSubscription)
                                    if (skavaItemQuantity !== cartItemQuantity && skavaItemIsSubscription === cartItemIsSubscription) {
                                        itemToUpdate = productsInCart.products[product.variants[z].item_id + isSubscriptionIdSuffix].itemId;
                                        quantityMatches = false;

                                    } else if (skavaItemSubscriptionInterval !== cartItemSubscriptionInterval && skavaItemIsSubscription === cartItemIsSubscription && cartItemIsSubscription) {
                                        itemToUpdate = productsInCart.products[product.variants[z].item_id + isSubscriptionIdSuffix].itemId;
                                        quantityMatches = false;
                                    }

                                    break;
                                }
                            }
                        }

                        if (!quantityMatches) {
                            productsToUpdate.push({
                                product: product,
                                itemId: itemToUpdate,
                                newQuantity: localCartItems[i].quantity,
                                isSubscription: localCartItems[i].isSubscription,
                                subscriptionInterval: localCartItems[i].subscriptionInterval,
                                subscriptionType: defaultSubscriptionType
                            });
                        }
                    }

                    // productsToAdd = []
                    if (productsToUpdate.length === 0) {
                        return finishCb();

                    } else {
                        cartChangesMade = true;
                        var numProcessed = 0;
                        var numFailed = 0;
                        var errors = {};

                        for (var x = 0; x < productsToUpdate.length; x++) {
                            var sendBody = {
                                quantity: productsToUpdate[x].newQuantity,
                                skus: [
                                    {
                                        skuId: productsToUpdate[x].product.sku_id,
                                        productId: productsToUpdate[x].product.product_id.toString(),
                                        type: 'DEFAULT'
                                    }
                                ],
                                properties: {},
                                isSubscription: productsToUpdate[x].isSubscription
                            };

                            if (productsToUpdate[x].isSubscription) {
                                sendBody.subscription = {
                                    frequencyPeriod: productsToUpdate[x].subscriptionInterval,
                                    frequencyType: productsToUpdate[x].subscriptionType
                                };
                            }

                            app.skava.sendRequest({
                                url: '/cart/' + productsToUpdate[x].itemId + '/',
                                data: JSON.stringify(sendBody),
                                method: 'PATCH'
                                }, function () {
                                    numProcessed++;
                                    if (numProcessed === productsToUpdate.length) {
                                        if (numFailed === 0) {
                                            return finishCb();
                                        } else {
                                            errorCb(errors.err1, errors.err2, errors.err3);
                                        }
                                    }
                                }, function(err1, err2, err3) {
                                    numFailed++;
                                    numProcessed++;
                                    if (numProcessed === productsToUpdate.length) {
                                        errorCb(err1, err2, err3);
                                    } else {
                                        errors.err1 = err1;
                                        errors.err2 = err2;
                                        errors.err3 = err3;
                                    }
                            });
                        }
                    }
                };

                deleteItems(function() {
                    addItems(function() {
                        updateItems(function () {
                            app.skava.getCart(function(result) {
                                self.updateBadge();
                                self.setCartTotal(result.grandTotal);
                                cb(result);

                            }, function(jqXHR, textStatus, errorThrown) {
                                if (jqXHR) {
                                    if (jqXHR.status === 400 || jqXHR.status === 500) {
                                        // empty cart, proceed
                                        cb({ items: [], grandtotal: 0});
                                    }

                                } else {
                                    errorCb(jqXHR, textStatus, errorThrown);
                                }
                            });
                        });
                    });
                });
            };


            app.skava.getCart(function(result) {
                sync(result.items);

            }, function (jqXHR, textStatus, errorThrown) {
                if (jqXHR && jqXHR.status === 400) {
                    // empty cart, proceed
                    sync([]);
                } else {
                    errorCb(jqXHR, textStatus, errorThrown);
                }
            });
        }
    };

    return self;
}());